import { useState, useEffect, useCallback  } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2 } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyAutoCompleteJavier from '../../../components/inputs/MyAutoCompleteJavier';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from 'axios';
import moment from 'moment-timezone';

function CrearEditarArgui({ open, onClose, refresh, carga, isEditing }) {

    //Función para formatear la fecha
    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const validationSchema = Yup.object({
        occurred: Yup.string().required('La fecha es obligatoria'),

        quantity: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('La cantidad es obligatoria')
        .min(0, 'La cantidad no puede ser negativa')
        .moreThan(0, 'La cantidad debe ser mayor que 0'),

        vehicle: Yup.string().required('El vehículo es obligatorio'),
        grupo: Yup.string()
                .oneOf(['TRACTORES', 'CAJAS'], 'El tipo seleccionado no es válido')
                .required('El tipo es obligatorio'),
    });

    const initialValues = 
    {
        occurred: carga?.occurred ? moment(formatDate(carga.occurred), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
        vehicle: carga?.vehicle || '',
        quantity: carga?.quantity || '',
        grupo:  carga?.product === 'DSL'
                ? 'TRACTORES'
                : carga?.product === 'ORD'
                ? 'CAJAS'
                : '',
        cliente: '',
        usuario: Cookies.get('ebt_nombre')
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        
        const payload = {  
            occurred: values.occurred,
            vehicle: values.vehicle,
            quantity: values.quantity,
            usuario: values.usuario
        };

        const formData = new FormData();

        formData.append('occurred', values.occurred);
        formData.append('vehicle', values.vehicle);
        formData.append('quantity', values.quantity);
        formData.append('tipoUnidad', values.grupo);
        formData.append('usuario', values.usuario);

        try 
        {
            if (isEditing) 
            {
                //let responseEditar = await myApi.put(`/cargasFuel/editarOxxo/${carga.id}`, payload);
                let responseEditar = await myApi.put(`/cargasFuel/editarArgui/${carga.id}`, formData);

                if(responseEditar.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga editada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseEditar.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseEditar.data.data || 'Ya existe una carga con esa fecha y unidad',
                            target: document.getElementById('dialog1')
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al editar carga',
                            text: responseEditar.data.data || 'Ocurrió un error desconocido',
                            target: document.getElementById('dialog1')
                        });
                    }

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                //let responseCrear = await myApi.post('/cargasFuel/crearOxxo', payload);
                let responseCrear = await myApi.post('/cargasFuel/crearArgui', formData);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga creada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseCrear.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseCrear.data.data || 'Ya existe una carga con esa fecha y unidad',
                            target: document.getElementById('dialog1')
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al crear carga',
                            text: responseCrear.data.data || 'Ocurrió un error desconocido',
                            target: document.getElementById('dialog1')
                        });
                    }

                    console.error('Error de API:', responseCrear.data);
                }
            }
        } 
        catch (error) 
        {
            Swal.fire({
                icon: 'error',
                title: 'Error del servidor',
                text: error.response?.data?.message || error.message || 'Ocurrió un error desconocido',
            });
            console.error('Error saving charge:', error);
        }
    };

    const [tractoresEBT, setTractoresEBT] = useState([]);
    const [tractoresTEDEL, setTractoresTEDEL] = useState([]);
    const [cajasEBT, setCajasEBT] = useState([]);
    const [cajasTEDEL, setCajasTEDEL] = useState([]);

    const fetchAllUnidades = useCallback(async () => 
    {
        const statuses = ['A', 'I', 'S'];
        const companies = ['EBT', 'TEDEL'];

        try {
            const tractorRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        { company, status, tractor: null }
                    )
                )
            );

            const cajaRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trailers/',
                        { company, status, trailer: null }
                    )
                )
            );

            const [tractorResponses, cajaResponses] = await Promise.all([
                Promise.all(tractorRequests),
                Promise.all(cajaRequests)
            ]);

            const tractoresRaw = tractorResponses.flatMap(r => r.data);
            const cajasRaw = cajaResponses.flatMap(r => r.data);

            const tractoresEBT = new Map();
            const tractoresTEDEL = new Map();
            const cajasEBT = new Map();
            const cajasTEDEL = new Map();

            tractoresRaw.forEach(t => {
                if (!t.tractor) return;

                const item = { value: t.tractor, label: t.tractor };

                if (t.company === 'EBT') {
                    tractoresEBT.set(t.tractor, item);
                } else if (t.company === 'TEDEL') {
                    tractoresTEDEL.set(t.tractor, item);
                }
            });

            cajasRaw.forEach(c => {
                if (!c.trailer) return;

                const item = { value: c.trailer, label: c.trailer };

                if (c.company === 'EBT') {
                    cajasEBT.set(c.trailer, item);
                } else if (c.company === 'TEDEL') {
                    cajasTEDEL.set(c.trailer, item);
                }
            });

            setTractoresEBT([...tractoresEBT.values()]);
            setTractoresTEDEL([...tractoresTEDEL.values()]);
            setCajasEBT([...cajasEBT.values()]);
            setCajasTEDEL([...cajasTEDEL.values()]);

        } catch (error) {
            console.error('Error cargando unidades', error);
        }
    }, []);

    useEffect(() => {
        fetchAllUnidades();
    }, [fetchAllUnidades]);


    return (
        <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{
    isEditing
      ? 'Editar Carga Manual de Arguindegui'
      : 'Crear Carga Manual de Arguindegui'
}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={{
                        ...initialValues
                    }}
                    enableReinitialize
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    context={{ isEditing }}
                >
                    {({ isSubmitting, handleSubmit, errors, touched, values, setFieldValue }) => {

                        const baseCatalog  =
                            values.grupo === 'TRACTORES' && values.cliente?.includes('EBT')
                                ? tractoresEBT
                                : values.grupo === 'TRACTORES' && values.cliente?.includes('TEDEL')
                                ? tractoresTEDEL
                                : values.grupo === 'CAJAS' && values.cliente?.includes('EBT')
                                ? cajasEBT
                                : values.grupo === 'CAJAS' && values.cliente?.includes('TEDEL')
                                ? cajasTEDEL
                                : [];
                        
                        const extraOption =
                        values.vehicle
                            ? [{ value: values.vehicle, label: values.vehicle }]
                            : [];

                        const catalog = [
                        ...extraOption,
                        ...baseCatalog.filter(o => o.value !== values.vehicle)
                        ];

                    return (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyDateTimePicker
                                        name="occurred"
                                        label="FECHA"
                                        error={touched.occurred && Boolean(errors.occurred)}
                                        helperText={touched.occurred && errors.occurred}
                                    />
                                    {errors.occurred && touched.occurred ? (
                                        <div style={{ color: '#D3302F', fontSize: '12px' }}>{errors.occurred}</div>
                                    ) : null}
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="grupo"
                                        label="TIPO"
                                        options={[
                                            { value: 'TRACTORES', label: 'TRACTORES' },
                                            { value: 'CAJAS', label: 'CAJAS' },
                                        ]}
                                        onChange={() => setFieldValue('vehicle', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="cliente"
                                        label="EMPRESA"
                                        options={[
                                            { value: 'EBT FREIGHT SA DE CV', label: 'EBT FREIGHT SA DE CV' },
                                            { value: 'TEDEL TRUCKING SA DE CV', label: 'TEDEL TRUCKING SA DE CV' },
                                        ]}
                                        onChange={() => setFieldValue('vehicle', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoCompleteJavier
                                        name="vehicle"
                                        label="UNIDAD"
                                        options={catalog} 
                                        key={`vehicle-${values.grupo}-${values.vehicle}`} 
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="quantity"
                                        label="CANTIDAD EN GALONES"
                                    />
                                </Grid2>

                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarArgui